import { Link } from 'react-router-dom';
import { scrollToSection } from '../utils/scrollToSection';

export const Footer = () => (
  <footer className="border-t border-charcoal/10 px-5 sm:px-10 lg:px-20 py-12 md:py-16 text-charcoal">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end justify-between gap-10">
      <div>
        <p className="font-grandslang text-3xl md:text-4xl leading-none mb-3">
          Daverose Tholley<span className="text-[#ff6347]">.</span>
        </p>
        <p className="eyebrow">Freetown — Accra</p>
      </div>

      <nav aria-label="Elsewhere" className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
        <a href="mailto:info@daverosetholley.com" className="hover:text-[#c93a22] transition-colors duration-300">Email</a>
        <a href="https://www.linkedin.com/in/daverose-tholley-915a7b151/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c93a22] transition-colors duration-300">LinkedIn ↗</a>
        <Link to="/cv" className="hover:text-[#c93a22] transition-colors duration-300">CV</Link>
      </nav>

      <div className="flex md:flex-col items-center md:items-end justify-between gap-3">
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
          className="eyebrow hover:text-charcoal transition-colors duration-300"
        >
          Back to top ↑
        </a>
        <p className="text-xs text-charcoal/60">© {new Date().getFullYear()} Daverose Tholley</p>
      </div>
    </div>
  </footer>
);
